

import React, { useEffect, useRef, useState } from "react";
import FormCreator from "../../components/Forms/FormCreator";
import Buttons from "../../components/ui/button/Buttons";
import MolGrid from "../../components/Grid/MolGrid";
import { MemberApplicationTaskListdata } from "./data/MemberApplicationTaskList.data";
import { MemberApplicationTaskListConfig } from "./data/MemberApplicationTaskListConfig";
import { useLazyGetSignUpDropDownsForCorporateMembersQuery } from "../../app/services/common/commonApi";
import { setAllDropDownField } from "./Utils/setFieldParameter";
import { useCorporateMembershipApplicationTaskListMutation } from "../../app/services/corporateMembership/corporateMemberApi";
import { encryptAESID } from "../../utils/Encryption";
import { useNavigate } from "react-router-dom";

const MemberApplicationTaskList = () => {
  const navigate = useNavigate()
  const molGridRef = useRef();
  const MemberApplicationRef = useRef();
  const [formData, setFormData] = useState(MemberApplicationTaskListdata);
  const [dataSource, setDataSource] = useState();
  const [paginationRequest, setPaginationRequest] = useState({
    pageNo: 1,
    pageSize: 20,
    endPage: 100,
    CompanyUENNumber: null,
    totalCount: 0,
    MembershipTypeId: null,
    StatusId: null,
  });

  const [getMemberList, { isSuccess, isLoading, data: memberListResponse }] = useCorporateMembershipApplicationTaskListMutation();
  const [signUpDropDownsForCorporateMembers, { data: corporateMemberDropDownsData, isLoading: corporateDropDownsLoading, isFetching: signUpDropDownsFetching }] = useLazyGetSignUpDropDownsForCorporateMembersQuery();

  useEffect(() => {
    signUpDropDownsForCorporateMembers();
    getMemberList(paginationRequest);
  }, [])

  useEffect(() => {
    if (!corporateDropDownsLoading && corporateMemberDropDownsData) {
      setAllDropDownField(corporateMemberDropDownsData);
    }
  }, [corporateDropDownsLoading, corporateMemberDropDownsData]);

  useEffect(() => {
    if (!isLoading && isSuccess && memberListResponse) {
      setPaginationRequest(prev => ({ ...prev, totalCount: memberListResponse.totalCount }));
      setDataSource(memberListResponse?.itemList);
    }
  }, [isLoading, isSuccess, memberListResponse]);

  const handleSearch = () => {
    if (!MemberApplicationRef.current) {
      return;
    }
    const taskListFormData = MemberApplicationRef?.current?.getFormData();
    const updatedPaginationRequest = {
      pageNo: 1,
      pageSize: 20,
      endPage: 100,
      CompanyUENNumber: taskListFormData?.companyNameOrUen || "",
      StatusId: taskListFormData?.statusId?.value || taskListFormData?.statusId,
      MembershipTypeId: taskListFormData?.membershipTypeId?.value || taskListFormData?.membershipTypeId
    };
    setPaginationRequest(updatedPaginationRequest);
    getMemberList(updatedPaginationRequest);
  };

  const handlePageChange = ({ pageNumber, pageSize }) => {
    const updatedPaginationRequest = { ...paginationRequest, pageNo: pageNumber, pageSize: pageSize };
    setPaginationRequest(updatedPaginationRequest);
    getMemberList(updatedPaginationRequest);
  };

  const handleClearClick = () => {
    const updatedFormData = { ...formData };
    updatedFormData.initialState = {
      membershipTypeId: null,
      statusId: null,
    };

    const request = {
      ...paginationRequest,
      CompanyUENNumber: null,
      totalCount: 0,
      MembershipTypeId: null,
      StatusId: null,
    };

    setPaginationRequest((prev) => ({ ...prev, ...request }));
    getMemberList(request);
    setFormData(updatedFormData);
  };

  const handleProcessClick = (data) => {
    //window.open(
      //`/memberapplicationtasklistdetailform/${encryptAESID(data?.sgbcCorporateMemberId)}?tasklistid=${encryptAESID(data?.sgbcCorporateMembershipApplicationTaskListId)}`);
    //window.open(`/memberapplicationtasklistdetailform/${encryptAESID(data?.sgbcCorporateMemberId)}?${encryptAESID(data?.sgbcCorporateMembershipApplicationTaskListId)}`)
    navigate(
      `/memberapplicationtasklistdetailform/${encryptAESID(data?.sgbcCorporateMemberId)}/${encryptAESID(data?.sgbcCorporateMembershipApplicationTaskListId)}`,
      // {
      //   state: {
      //     tasklistId: encryptAESID(
      //       data?.sgbcCorporateMembershipApplicationTaskListId
      //     )
      //   },

      // }
    );
  }

  const actionHandler = {
    UPDATE: handleProcessClick,
  };

  return (
    <div className="corporate-member-list member-application-task-list">
      <div className="member-list-filter row">
        <div className="row status-input">
          {corporateMemberDropDownsData &&
            <FormCreator
              ref={MemberApplicationRef}
              {...formData}
            />
          }
        </div>
        <div className="right-side-btn">
          <Buttons
            buttonText="Clear"
            buttonTypeClassName="btn btn-secondary mb-2"
            onClick={handleClearClick}
          />
          <Buttons
            buttonText="Search"
            buttonTypeClassName="success-btn"
            onClick={handleSearch}
          />
        </div>
      </div>

      <div className="member-list membership-app-list">
        <MolGrid
          ref={molGridRef}
          configuration={MemberApplicationTaskListConfig}
          dataSource={dataSource}
          allowPagination={true}
          pagination={paginationRequest}
          onPageChange={handlePageChange}
          onActionChange={actionHandler}
        />
      </div>
    </div>
  );
};

export default MemberApplicationTaskList;
